module.exports = require('../../full/instance/index-of');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/instance/index-of.js
// module id = 1276
// module chunks = 25